import { isMaxLength, validateRules } from '@foradevelopment/fora-ui';

import { typedT } from '../../../i18n/i18n';

export const validateCoAddress = (value: string) => {
  const rules = [isMaxLength(typedT('errorMessages.validation.coAddress'), 40)];
  return validateRules(rules, value);
};
